import { FlowControlOutcome, FlowControlRefusalListParams, FlowControlStage } from '../../../../ticket-card/core/refusal.types'
import { nonEmpty, toPayoutRefusalParams } from '../../../../payout-tickets/refusals/core/consts'
import { PayoutRefusalFilterState } from '../../../../payout-tickets/refusals/core/types'

export interface FlowControlRefusalFilterState extends Omit<PayoutRefusalFilterState, 'reasons'> {
  stages?: string[]
  outcomes?: string[]
  matchingReasons?: string[]
}

export const toFlowControlRefusalParams = (f: FlowControlRefusalFilterState, page: number): FlowControlRefusalListParams => {
  const { reasons: _unused, ...base } = toPayoutRefusalParams(f, page)

  return {
    ...base,
    stages: nonEmpty(f.stages) as FlowControlStage[] | undefined,
    outcomes: nonEmpty(f.outcomes) as FlowControlOutcome[] | undefined,
    matchingReasons: nonEmpty(f.matchingReasons),
  }
}
